module.exports = __webpack_public_path__ + "img/2_140.a4b1a068.png";